import { useState } from 'react';
const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {

    e.preventDefault();
    if (!email) return;
    setStatus('submitting');
    setErrorMsg('');
    try {
      const res = await fetch(`${API_BASE}/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, fullName: fullName || undefined }),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.error?.message || 'Something went wrong');
      setStatus('success');
      setEmail('');
      setFullName('');
      handleSuccessNewsletter()
      // onSuccess?.();
    } catch (err) {
      setStatus('error');
      setErrorMsg(err.message);
    }
  };

  const handleSuccessNewsletter = () => {
    const SUBSCRIBED_KEY = 'iasc_newsletter_subscribed'; 

    localStorage.setItem(SUBSCRIBED_KEY, 'true');
    // setTimeout(() => setOpen(false), 1800); // brief pause so they see the confirmation before it closes
  };

  return (
    <footer className="bg-[#00255a] text-white py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-3 mb-8">
            <a href="/" className="flex items-center gap-3">
            <img src="/images/logo_w_nobg.png" alt="IASC Consultancy" className="h-12 w-12 object-contain rounded-lg bg-white" />
            <h4 className="text-2xl font-bold">IASC Consultancy</h4>
            </a>
          </div>
          <p className="text-white/70 mb-8">
            Trusted study abroad guidance for scholarships, university admissions, student visas and international career opportunities.
          </p>
          <div className="flex gap-4">
            <a className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10" href="https://instagram.com/iasc_consultancy" target="_blank" rel="noreferrer">
              <span className="material-symbols-outlined">public</span>
            </a>
            <a className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10" href="mailto:agentzw@iascupdate.com">
              <span className="material-symbols-outlined">mail</span>
            </a>
            <a className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10" href="https://wa.me/263775827371" target="_blank" rel="noreferrer">
              <span className="material-symbols-outlined">call</span>
            </a>
          </div>
        </div>

        <FooterCol title="Company" links={[
          { label: 'About Us', href: '/about' },
          { label: 'Careers', href: '/agents' },
          { label: 'FAQ', href: '/faq' },
        ]} />

        <FooterCol title="Services" links={[
          { label: 'University Admissions', href: '/openings?type=STUDY' },
          { label: 'Visa Counseling', href: '/about' },
          { label: 'Job Placements', href: '/openings?type=JOB' },
          { label: 'Course Directory', href: '/courses' },
        ]} />

        <div>
          <h5 className="text-xs uppercase tracking-widest text-white/50 mb-8">Newsletter</h5>
          <p className="text-white/70 mb-6">Get updates on scholarships to study abroad, courses and international job openings.</p>
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            <input className="bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder:text-white/40 outline-none" placeholder="Email Address" type="email" onChange={(e) => setEmail(e.target.value)} />
            {
              status === 'success' &&
                (
                  <div>
                    <p className="text-sm font-semibold text-emerald-600 flex items-center gap-2">
                      <span className="material-symbols-outlined text-[18px]">check_circle</span>
                      You're subscribed — we'll email you about new openings.
                    </p>
                  </div>
                )
            }
            <button className="bg-[#365da3] text-white font-bold py-3 rounded-lg hover:bg-[#365da3]/90 transition-all">Subscribe</button>
          </form>
        </div>
      </div>

      <div className="max-w-[1280px] mx-auto px-4 md:px-6 pt-16 mt-16 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6">
        <p className="text-white/50 text-sm">© 2026 IASC Consultancy. All rights reserved.</p>
        <div className="flex gap-8">
          <a className="text-white/50 hover:text-white text-sm" href="/privacy">Privacy Policy</a>
          <a className="text-white/50 hover:text-white text-sm" href="/terms">Terms of Service</a>
          <a className="text-white/50 hover:text-white text-sm" href="/contact">Contact Us</a>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h5 className="text-xs uppercase tracking-widest text-white/50 mb-8">{title}</h5>
      <ul className="space-y-4">
        {links.map((l) => (
          <li key={l.label}><a className="text-white/70 hover:text-white transition-colors" href={l.href}>{l.label}</a></li>
        ))}
      </ul>
    </div>
  );
}
